<template>
  <v-row>
    <v-col class="mx-2">
      <Table
        :items="items"
        :headers="headers"
        :openDialog="openDialog"
        @headersUpdated="updateHeadersTables"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <FormOrder
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import FormOrder from "../../../Complement/FormOrder.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import tables from "../../../../store/tablas/tables";
import Tables from "../../../../models/unidadDeNegocios/tables";
import businessUnits from "../../../../store/unidadesDeNegocios/businessUnits";
import Vue from "vue";
import { VSelect, VTextField } from "vuetify/lib";
Vue.component("v-select", VSelect);
Vue.component("v-text-field", VTextField);

export default {
  components: {
    Table,
    FormOrder,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      titleTable: this.$tc("businessUnits.businessUnits"),
      title: this.$tc("businessUnits.tables"),
      titleDelete: this.$tc("businessUnits.toTableRelation"),
      isLoading: true,
      nameOper: "",
      maxWidth: ["500px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      dataInputs: [
        {
          name: "cat",
          label: this.$tc("businessUnits.cat"),
          data: "",
          type: "number",
          rules: [
            (v) => {
              const isValidNumber = /^[0-9]+$/.test(v);
              const isInRange = isValidNumber && v >= 1 && v <= 1000;
              return (
                isInRange || this.$tc("costCenter.rulesDatacodRegExt3chart")
              );
            },
          ],
        },
      ],
    };
  },
  computed: {
    headers() {
      return configTable.state.colums.tables;
    },
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "name",
            type: "select",
            label: this.$tc("businessUnits.nameTable"),
            items: [],
            itemText: "name",
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
          },
          {
            id: 2,
            show: true,
            data: "",
            name: "cat",
            type: "select",
            label: this.$tc("businessUnits.cat"),
            items: [],
            itemValue: "cat",
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 2,
          },
          {
            id: 3,
            show: true,
            data: true,
            name: "isDefault",
            type: "check",
            label: "Por defecto",
            order: 3,
          },
        ],
      };
    },
    items() {
      if (
        !businessUnits.state.edit.tablas ||
        businessUnits.state.edit.tablas.length === 0
      ) {
        return [];
      }
      return businessUnits.state.edit.tablas.map((item) => {
        return Tables.fromJson(item);
      });
    },
    allTables() {
      return tables.state.tables;
    },
    allCats() {
      return businessUnits.state.cats;
    },
    tablesSelected() {
      const editTablas = businessUnits.state.edit.tablas;
      if (!editTablas || editTablas.length === 0) {
        return this.allTables;
      }

      return this.allTables.filter(
        (model) => !editTablas.some((selected) => selected.tabla == model.name)
      );
    },

    mode: {
      get() {
        return businessUnits.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return businessUnits.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return businessUnits.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  mounted() {
    Promise.all([
      tables.dispatch("getTables"),
      businessUnits.dispatch("getCats"),
    ])
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        console.error("Error occurred:", error);
        this.isLoading = false;
      });
  },
  methods: {
    async refreshItems() {
      await businessUnits.dispatch(
        "getBusinessUnitsId",
        businessUnits.state.unitId
      );
    },
    updateHeadersTables(headers) {
      const updatedColums = { ...configTable.state.colums, tables: headers };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    addTable(form) {
      let payload = {
        unNegocioId: businessUnits.state.edit.unNegocioId,
        tabla: form.name,
        cat: Number(form.cat),
        def: form.isDefault === "true",
      };

      businessUnits.commit("setNew", payload);
      businessUnits
        .dispatch("addBusinessUnitsToTable")
        .then(() => {
          this.showAlert(
            this.$tc("businessUnits.addTableToRelationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
          reject(e);
        });
      this.reset(false);
    },
    editTable(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.unNegocioId = businessUnits.state.edit.unNegocioId;
        payload.nameTable = form.name;
        businessUnits.commit("setEditRelation", payload);
        businessUnits
          .dispatch("editBusinessUnitsToTable")
          .then(() => {
            this.showAlert(
              this.$tc("businessUnits.editTableToRelationSuccess"),
              "#82A1D0"
            );
          })
          .catch((e) => {
            this.showAlert(e.response.data.error.message, "#FF8D58");
            reject(error);
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      newItems.def = newItems.isDefault === "true";
      newItems.cat = Number(newItems.cat);
      const changes = {};
      const oldItem = this.oldItems;
      if (oldItem) {
        if (oldItem.cat !== newItems.cat) {
          changes.cat = newItems.cat;
        }
        if (oldItem.isDefaultBool !== newItems.def) {
          changes.def = newItems.def;
        }
      }

      return changes;
    },

    setEdit(item) {
      this.parameters.items[0].data = item.name;
      this.parameters.items[1].data = item.cat;
      this.parameters.items[2].data = item.isDefaultBool;
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.parameters.items[0].items = this.tablesSelected;
          console.log(this.allCats);
          this.parameters.items[1].items = this.allCats;
          businessUnits.commit(
            "setModeFormRelation",
            this.$tc("businessUnits.addTableToRelation")
          );
          businessUnits.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.parameters.items[0].items = this.allTables;
          this.parameters.items[1].items = this.allCats;
          this.oldItems = item;
          businessUnits.commit(
            "setModeFormRelation",
            this.$tc("businessUnits.editTableToRelation")
          );
          await this.setEdit(item);
          businessUnits.commit("setOpenFormRelation", true);
          break;
        case "delete":
          businessUnits.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            unNegocioId: businessUnits.state.edit.unNegocioId,
          };
          break;

        default:
          break;
      }
    },

    reset(value) {
      businessUnits.commit("setOpenFormRelation", value);
      this.parameters.items.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addTable(items);
          break;
        case "edit":
          this.editTable(items);
          break;
        default:
          break;
      }
    },
    deleteItem() {
      businessUnits.commit("setItemDelete", this.itemToDelete);
      businessUnits
        .dispatch("deleteBusinessUnitsToTable")
        .then(() => {
          this.openDelete = false;
          businessUnits.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("businessUnits.deleteTableToRelationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      businessUnits.commit("setOpenDelete", false);
    },
  },
};
</script>
